var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPedroAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1300,
    height: 1300,
    viewBox: "0 0 1300 1300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M650 1300C290.71 1300 0 1008.86 0 650C0 290.71 291.141 0 650 0C1009.29 0 1300 291.141 1300 650C1300.43 1009.29 1009.29 1300 650 1300Z",
    fill: "#F4DA92"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26_635",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1301,
    height: 1300
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M650 1300C290.71 1300 0 1008.86 0 650C0 290.71 291.141 0 650 0C1009.29 0 1300 291.141 1300 650C1300.43 1009.29 1009.29 1300 650 1300Z",
    fill: "#F7C0B5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26_635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1015.73 1197.33C1012.7 1199.5 1009.23 1201.66 1006.2 1203.83C1002.73 1206 999.698 1208.16 996.231 1209.9C993.198 1211.63 990.598 1213.36 987.564 1215.1C987.131 1215.53 986.698 1215.53 986.264 1215.96C976.298 1222.03 965.898 1227.66 955.498 1232.86C952.464 1234.6 948.998 1236.33 945.964 1237.63C945.964 1237.63 945.531 1238.06 945.098 1238.06C941.631 1239.8 938.164 1241.53 934.698 1243.26C927.764 1246.73 920.398 1249.76 913.464 1252.8C909.998 1254.53 906.098 1255.83 902.631 1257.13C899.164 1258.43 895.264 1260.16 891.798 1261.46C888.331 1262.76 884.431 1264.5 880.964 1265.8C880.964 1265.8 880.964 1265.8 880.531 1265.8C877.064 1267.1 873.164 1268.4 869.698 1269.7C861.898 1272.3 853.664 1274.9 845.864 1277.5C843.264 1278.36 840.231 1279.23 837.631 1280.1C829.398 1282.7 821.164 1284.86 812.931 1286.6C809.898 1287.46 806.864 1287.9 803.398 1288.76C795.598 1290.5 787.364 1292.23 779.564 1293.96C777.831 1294.4 776.531 1294.4 774.798 1294.83C772.198 1295.26 769.164 1295.7 766.564 1296.13C762.664 1296.56 759.198 1297.43 755.298 1297.86C753.564 1298.3 751.831 1298.3 750.098 1298.73C747.931 1299.16 745.331 1299.6 742.731 1299.6C735.798 1300.46 728.431 1301.33 721.498 1302.2C719.331 1302.63 716.731 1302.63 714.564 1303.06H714.131C711.098 1303.5 708.064 1303.5 705.031 1303.93C701.998 1304.36 698.964 1304.36 695.931 1304.36C694.198 1304.36 692.031 1304.8 690.298 1304.8C686.831 1304.8 683.798 1305.23 680.764 1305.23C676.431 1305.23 672.531 1305.66 668.198 1305.66C663.864 1305.66 659.964 1305.66 655.631 1305.66C652.598 1305.66 649.564 1305.66 646.531 1305.66C464.098 1303.06 299.431 1225.5 182.431 1102.43C182.431 1102.43 182.431 1102 181.998 1102C195.431 1075.56 245.264 1027.9 297.264 988.465C363.131 938.632 456.298 907.865 456.298 907.865C456.298 907.865 517.398 897.898 744.031 945.132C916.931 981.532 990.598 1129.3 1015.73 1197.33Z",
    fill: "#FEE4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.131 1065.16C783.031 1109.8 724.098 1136.23 624.865 1096.36C503.098 1046.96 456.298 907.865 456.298 907.865C449.798 808.198 434.631 722.832 434.631 722.832C575.465 710.698 741.865 875.365 741.865 875.365L760.931 956.832C762.665 963.765 766.131 969.832 771.331 974.165C780.431 989.765 798.198 1036.56 792.131 1065.16Z",
    fill: "#FEE4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.331 974.599C688.564 970.265 627.464 958.132 562.031 840.699C617.497 889.665 682.931 908.299 751.831 916.965L760.931 956.832C762.664 964.199 766.131 970.265 771.331 974.599Z",
    fill: "#EFBDA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.498 452.432C950.298 488.832 954.198 518.298 932.964 615.365C911.731 712.432 952.464 809.498 850.198 898.332C781.298 958.132 660.831 969.398 564.631 903.965C532.131 881.865 502.231 851.098 477.964 810.798C458.898 779.165 436.798 749.265 412.098 721.965C377.864 684.698 336.698 609.732 357.064 477.132C389.998 261.332 603.631 236.632 729.731 260.465C855.831 284.298 921.264 356.232 942.498 452.432Z",
    fill: "#FEE4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.797 621.865C527.797 621.865 514.364 556.865 451.097 564.665C396.497 571.598 377.431 702.465 501.364 738.865",
    fill: "#FEE4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.465 679.498C497.465 679.498 481.865 669.532 483.598 652.198C486.198 631.832 483.598 619.265 474.065 615.365C450.231 605.398 445.465 633.132 446.331 636.598",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828.097 721.532C828.097 721.532 844.564 722.398 860.164 703.765C868.831 693.365 876.197 680.365 871.431 676.465C866.664 672.132 788.231 684.265 783.031 694.665C777.831 705.065 808.164 721.532 828.097 721.532Z",
    fill: "#EFBDA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.098 575.932C841.098 575.932 841.965 617.098 868.398 663.032C880.098 683.398 862.331 716.765 823.765 722.398",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M606.231 743.632C630.882 743.632 650.865 727.141 650.865 706.799C650.865 686.456 630.882 669.965 606.231 669.965C581.581 669.965 561.598 686.456 561.598 706.799C561.598 727.141 581.581 743.632 606.231 743.632Z",
    fill: "#F2A5B2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M926.031 670.832C924.731 695.098 925.164 718.932 923.431 742.765C904.364 738.432 890.498 724.132 890.498 707.232C890.498 689.032 905.664 674.298 926.031 670.832Z",
    fill: "#F2A5B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.78 1116.61C996.25 1037.31 900.917 1004.37 848.483 984.873C844.15 963.206 835.917 939.373 822.917 916.406C802.983 928.54 780.017 937.64 756.184 942.406L759.65 956.706C761.383 963.64 770.05 995.706 756.617 1036.87C745.35 1071.54 699.85 1087.14 622.717 1052.04C472.35 984.006 455.017 907.306 455.017 907.306C452.417 865.706 448.084 826.706 444.184 795.073C397.384 805.473 343.217 826.706 313.75 871.34C277.35 925.94 263.917 981.406 267.384 1025.61C204.117 1065.91 106.184 1127.01 74.1168 1236.21C32.5168 1378.34 39.4502 1465.44 39.4502 1465.44H1159.18C1157.88 1465.87 1141.42 1224.51 1057.78 1116.61Z",
    fill: "#43434D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.283 974.473C388.283 974.473 414.716 1077.17 530.416 1148.24",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.05 984.873C848.05 984.873 878.817 1117.91 811.65 1179.01",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.183 1158.64C639.183 1158.64 616.65 1224.51 622.717 1270.01",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.417 1154.74C777.417 1154.74 794.318 1191.57 806.451 1250.07",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.517 1026.04C266.517 1026.04 302.05 1170.77 513.517 1213.24",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.617 1279.97L607.55 1278.24C600.617 1277.37 595.417 1270.87 596.717 1263.94L603.217 1231.44C604.95 1222.34 613.617 1215.84 622.717 1217.14C631.817 1218.01 639.183 1225.81 639.183 1235.34L639.617 1268.71C639.617 1275.21 633.55 1280.84 626.617 1279.97Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.517 1260.04L807.317 1266.54C800.384 1269.14 793.017 1264.81 791.717 1257.87L783.917 1225.81C781.75 1216.71 786.517 1207.61 795.617 1204.14C804.284 1201.11 814.25 1205.01 818.15 1213.24L832.45 1243.14C835.484 1249.64 832.45 1257.44 825.517 1260.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.62 1250.07C1016.62 1250.07 1040.88 1386.14 1031.35 1465.87",
    stroke: "#544D4D",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.71 590.249C699.71 590.683 699.71 591.116 699.71 591.116L699.277 603.249C698.843 613.649 690.177 621.449 679.777 621.016C669.377 620.583 661.577 611.483 662.443 601.516L662.877 589.383C662.877 587.216 663.743 584.616 664.61 582.883L699.277 584.616C699.277 586.349 699.71 588.083 699.71 590.249Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.841 599.783L880.408 611.049C879.975 620.583 871.742 627.949 862.208 627.516C852.675 627.083 845.308 618.849 845.742 609.316L846.175 598.049C846.175 595.883 846.608 593.716 847.475 591.983L879.975 593.283C880.842 595.449 880.841 597.616 880.841 599.783Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.042 530.882C752.576 532.182 759.942 522.216 756.476 512.682C754.742 507.482 751.709 502.716 746.942 499.682C732.209 490.582 677.176 489.716 648.142 510.516C622.576 529.582 699.709 524.816 743.042 530.882Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.074 535.649C855.274 535.649 850.508 525.682 854.408 517.449C856.574 513.116 859.608 509.216 863.941 507.049C877.374 500.549 913.341 504.449 929.374 526.549C943.674 546.049 899.041 535.216 863.074 535.649Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.875 585.482L698.842 584.182L664.175 582.882L656.375 582.449",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.042 594.149L879.975 593.283L847.475 591.983H846.175",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.997 777.919C820.997 777.919 765.964 752.352 739.531 766.219",
    stroke: "#423232",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.541 366.632C940.774 477.999 852.807 455.899 767.874 429.032C468.441 334.132 520.007 624.032 516.107 618.832C506.574 600.632 486.207 578.099 447.641 582.865C397.374 589.365 377.007 700.732 471.041 746.665C468.874 766.599 454.574 783.499 438.107 795.632C393.907 758.365 325.441 686.432 299.874 582.432C290.341 544.299 294.241 512.665 298.141 487.965C310.707 411.265 358.374 395.232 358.374 395.232C360.107 314.199 444.607 224.932 586.741 227.965C729.307 230.132 1002.31 255.265 971.541 366.632Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M975.007 500.532C970.674 528.699 958.54 550.365 941.64 566.399C948.14 519.165 944.674 496.632 939.04 470.199C926.907 416.032 900.907 369.232 857.574 334.565C879.24 332.832 901.34 337.599 921.274 350.165C921.274 350.165 949.874 370.099 960.707 434.232C964.174 452.865 978.907 472.799 975.007 500.532Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.407 228.399C621.407 228.399 786.074 164.265 844.141 185.499C892.241 203.265 874.907 252.665 874.907 252.665C874.907 252.665 957.241 231.865 1001.87 285.599C1046.51 339.332 994.941 409.099 965.474 434.665C965.474 434.665 1011.84 446.799 1007.07 486.232C1001.44 535.632 941.207 565.965 941.207 565.965C941.207 565.965 962.007 523.499 958.974 482.765C955.941 442.032 960.707 412.999 930.807 383.532C900.907 353.632 829.841 381.799 753.141 343.665C676.874 305.532 621.407 228.399 621.407 228.399Z",
    fill: "#423232"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPedroAvatar);
export default __webpack_public_path__ + "static/media/pedro-avatar.e55f87ef2ca146822120e7522258f3cd.svg";
export { ForwardRef as ReactComponent };